import axios from 'axios';

import { APP_BASE_URL } from './config';

const headers = {
  'Content-Type': 'application/json'
};

const appNetworkManager = axios.create({
  baseURL: APP_BASE_URL,
  headers
});

appNetworkManager.interceptors.request.use((req) => {
  if (process.env.NODE_ENV !== 'production') {
    console.log('API Req', req);
  }
  // req.data = keysToSnake(req.data);
  return req;
});

appNetworkManager.interceptors.response.use(
  (res) => {
    if (process.env.NODE_ENV !== 'production') {
      console.log('API Res', res);
    }
    // res.data = keysToCamel(res.data);
    return res;
  },
  (error) => {
    if (process.env.NODE_ENV !== 'production') {
      console.log('API Error', error);
    }
    if (error.response) {
      // error.response.data = keysToCamel(error.response.data);
      console.log(error.response.data);
    }

    return Promise.reject(error);
  }
);

export { appNetworkManager };
